








import { Component, Vue } from 'vue-property-decorator';
import { exit } from '@/utils/utils';

@Component
export default class ExitButton extends Vue {
  exit() {
    exit();
  }
}
